import { useEffect, useState } from "react";
import { FaCrown } from "react-icons/fa6";
import "./DisplayForm.scss";
import { ProductModelType } from "@ltypes/product";

export type DisplayFormItemType = {
    id: number,
    background: string,
    subscription?: boolean,
};

type DisplayFormProps = {
    className?: string,
    label: string,
    value: number,
    items: Array<DisplayFormItemType>,
    productModelType?: ProductModelType,
    onChange?: (id: number) => void,
};

function DisplayForm(props: DisplayFormProps) {
    const [value, setValue] = useState<number>(props.value);

    const handleClick = (itemId: number) => {
        if(props.onChange)
            props.onChange(itemId);
        setValue(itemId);
    };

    useEffect(() => {
        setValue(props.value);
    }, [props.value]);

    return (
        <div className="input-display-mode">
            <span className="textfield-label">{props.label}</span>
            <div className={`input-display-mode-list ${props.className ?? ''}`}>
                {props.items.map((item: DisplayFormItemType) => (
                    <div key={item.id} onClick={() => handleClick(item.id)} className={`input-display-mode-item ${props.productModelType === ProductModelType.LEGACY ? 'input-display-mode-item-legacy' : props.productModelType === ProductModelType.STANDARD ? 'input-display-mode-item-standard' : ''} ${(value === item.id ? 'active' : '')} img-${item.background} ${item.subscription ? 'subscription' : ''}`}>
                        {item.subscription && <FaCrown size="1rem"/>}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default DisplayForm;
